module.exports = __webpack_public_path__ + "img/zgwab.f587a6ef.png";